import { get } from 'lodash-es'
import ArticleNumbersNew from '@/js/components/Forms/ComplaintForm/_data/engine/impulse-articleNumbers-new.json'
import ArticleNumbersOverhauled from '@/js/components/Forms/ComplaintForm/_data/engine/impulse-articleNumbers-overhauled.json'
import ArticleNumbersLegacy from '@/js/components/Forms/ComplaintForm/_data/engine/impulse-articleNumbers-legacy.json'
import ArticleNumbersRepairWithPickup from '@/js/components/Forms/ComplaintForm/_data/engine/impulse-articleNumbers-repair-with-pickup.json'

import {
  ENGINE_TYPES,
  REPAIR_PROCESS_TYPES,
  COMPLAINT_FORM_IMPULSE_PRODUCT_DATA_CONSTANTS as PDC,
} from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'

export default {
  data() {
    return {
      allItemData: [ArticleNumbersNew, ArticleNumbersOverhauled],
      allModelTypeKeys: [
        { dataKey: 'impulseEVO', label: PDC.MODEL_TYPE.MODEL_TYPE_IMPULSE_EVO },
        { dataKey: 'impulse2', label: PDC.MODEL_TYPE.MODEL_TYPE_IMPULSE_2_0 },
        { dataKey: 'impulse', label: PDC.MODEL_TYPE.MODEL_TYPE_IMPULSE },
        { dataKey: 'continental', label: PDC.MODEL_TYPE.MODEL_TYPE_CONTINENTAL },
      ],
      allEngineTypeKeys: Object.keys(ENGINE_TYPES).map(key => ENGINE_TYPES[key]),
      motorClaimTypes: {
        CALCULATION_DESIRE_WARRANTY: 0,
        CALCULATION_DESIRE_POOL_ENGINE_IN_WARRANTY_PERIOD: 1,
        CALCULATION_DESIRE_GUARANTEE: 1,
        CALCULATION_DESIRE_POOL_ENGINE_WITH_LEGACY_DEVICE_PICK_UP: 5,
        CALCULATION_DESIRE_POOL_ENGINE_WITHOUT_LEGACY_DEVICE_PICK_UP: 4,
        CALCULATION_DESIRE_NEW_ENGINE: 4,
        CALCULATION_DESIRE_PRODUCT_LIABILITY: 3,
        CALCULATION_DESIRE_WARRANTY_AND_GUARANTEE: 2,
        CALCULATION_DESIRE_TRANSPORTATION_DAMAGE: 4,
        CALCULATION_DESIRE_WORKING_TIME_COMPENSATION: 5,
        CALCULATION_DESIRE_FEE_BASED: 2,
        CALCULATION_DESIRE_NEW_ENGINE_WITH_LEGACY_DEVICE_PICK_UP: 5,
        CALCULATION_DESIRE_NEW_ENGINE_IN_WARRANTY_PERIOD: 1,
        CALCULATION_DESIRE_WARRANTY_WITHOUT_DEVICE_PICKUP_FOR_NO_PICK_UP_COUNTRIES: 4,
      },
    }
  },
  methods: {
    getModelTypeDataKey(modelType, allModelTypeKeys) {
      let modelTypeDataKey

      if (modelType) {
        allModelTypeKeys.forEach(item => {
          if (item.label === modelType) {
            modelTypeDataKey = item.dataKey
          }
        })
      }

      return modelTypeDataKey
    },
    getFilteredItems(
      modelTypeDataKey,
      engineType,
      repairProcessType,
      addLegacyEngines,
      calculationWishItem,
    ) {
      const path = ['data', modelTypeDataKey, engineType]
      let filteredItems = []

      switch (repairProcessType) {
        case REPAIR_PROCESS_TYPES.POOL: {
          filteredItems = get(ArticleNumbersOverhauled, path, [])
          break
        }

        case REPAIR_PROCESS_TYPES.NEW_ENGINE: {
          filteredItems = get(ArticleNumbersNew, path, [])
          break
        }

        case REPAIR_PROCESS_TYPES.REPAIR: {
          filteredItems = [
            ...get(ArticleNumbersNew, path, []),
            ...get(ArticleNumbersOverhauled, path, []),
            ...get(ArticleNumbersRepairWithPickup, path, []),
          ]
          break
        }

        // REPAIR_PROCESS_TYPES.REPAIR_WITHOUT_PICKUP
        default: {
          filteredItems = [
            ...get(ArticleNumbersNew, path, []),
            ...get(ArticleNumbersOverhauled, path, []),
          ]
        }
      }

      return [...filteredItems, ...(addLegacyEngines ? get(ArticleNumbersLegacy, path, []) : [])]
        .filter(item => {
          const allowed = get(item, 'allowed')
          // console.log(
          //   'getFilteredItems',
          //   allowed,
          //   get(this.motorClaimTypes, calculationWishItem),
          //   repairProcessType,
          //   allowed
          //     ? allowed.includes(
          //         `${get(this.motorClaimTypes, calculationWishItem)}-${repairProcessType}`,
          //       )
          //     : true,
          // )
          return allowed
            ? allowed.includes(
                `${get(this.motorClaimTypes, calculationWishItem)}-${repairProcessType}`,
              )
            : true
        })
        .map(item => this.transformItem(item))
    },
    transformItem({ articleNumber, label, sapArticleNumber } = { articleNumber: '', label: '' }) {
      const translationKey = `complaintForm.ticket.engine.label.${articleNumber}`
      const translation = this.$t(translationKey)
      return {
        text: `${articleNumber} (${sapArticleNumber}) - ${
          translationKey === translation ? label : translation
        }`,
        label: translationKey === translation ? label : translation,
        value: articleNumber,
        valueSap: sapArticleNumber,
      }
    },
  },
}
